$(document).ready(function () {
  const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,8}$/;
  $(".js-contact-input").on("keyup", function() {
    $(".js-contact-input").val($(this).val());
    if (regex.test($(this).val())
        && $(".js-contact-checkbox").prop("checked")) {
      $(".js-contact-wrap").removeClass("disabled");
    } else {
      $(".js-contact-wrap").addClass("disabled");
    }
  });
  $(".js-contact-button").on("mouseenter", function() {
    $(this).parent().addClass("hover");
  });
  $(".js-contact-button").on("mouseleave", function() {
    $(this).parent().removeClass("hover");
  });
  $(".js-contact-checkbox").on("change", function() {
    if ($(this).prop("checked")
        && regex.test($(".js-contact-input").val())) {
      $(".js-contact-wrap").removeClass("disabled");
    } else {
      $(".js-contact-wrap").addClass("disabled");
    }
  });
  $(".js-contact-form").on("submit", function (e) {
  	e.preventDefault();

  	var btn = $(".js-contact-button");
	$.ajax({
		url: 'https://user-aggregator.owlcat.games/api/subscribe-ext/946',
		type: 'POST',
		headers: {
			"Accept": "application/json",
		},
		datatype: 'JSON',
		data: {
			'email': $(".js-contact-input").val()
		},
		success: function (data) {
			$(".js-contact-input").val('');
			$(".js-contact-checkbox").prop('checked', false);
      		$(".js-contact").addClass('result');
		},
		error: function (data) {
			console.log('error', data);
		},
		beforeSend: function () {
			btn.attr('disabled', true);
		},
		complete: function () {
			btn.removeAttr('disabled');
		}
	});
  });
});



// WEBPACK FOOTER //
// ./src/js/pages/main/contact.js